import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';  
import { faUserMd, faHeadset, faClinicMedical } from '@fortawesome/free-solid-svg-icons';  
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules'; 
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom'; 
import Footer from './footer';




function Home() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };
 

  return (
    <div className="font-sans bg-gray-50 text-gray-900">
  

     
      <section id="home" className="bg-gray-100 text-center paa" style={{ backgroundImage: `url('/doc.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <h1 className="text-4xl font-bold mb-4">Welcome to Guardians Home Care</h1>
        <p className="text-xl mb-6">Your trusted partner for doctor visits and medical equipment rentals at home.</p>
        <a href="https://wa.me/+919910967118" className="button-33" role="button" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Book Now
        </a>
      </section>

      
      <section id='services' className="container mx-auto py-16 px-4">
  <h2 className="text-3xl font-semibold mb-8">Our Services</h2>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    <div className="service-card bg-white shadow-md rounded-lg p-6 text-center">
      <h3 className="text-2xl font-semibold mb-4">
        <FontAwesomeIcon icon={faUserMd} className="mr-2 text-teal-600" /> Doctor Home Visit
      </h3>
      <p>Receive top-notch medical care at your doorstep.</p>
      <img src="/homevisit.jpg" alt="Doctor Home Visit" className="mt-4 w-full h-auto rounded-lg" />
      <div className='b'>
        <a href="https://wa.me/+919910967118" className="button-85 b" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Book Now
        </a>
      </div>
    </div>

    <div className="service-card bg-white shadow-md rounded-lg p-6 text-center">
      <h3 className="text-2xl font-semibold mb-4">
        <FontAwesomeIcon icon={faClinicMedical} className="mr-2 text-teal-600" /> Medical Equipment Rental
      </h3>
      <p>Rent essential medical equipment for short or long-term use.</p>
      <img src="./devices.jpg" alt="Medical Equipment Rental" className="mt-4 w-full h-auto rounded-lg" />
      <div className='b'>
        <a href="https://wa.me/+919910967118" className="button-85" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Book Now
        </a>
      </div>
    </div>

    <div className="service-card bg-white shadow-md rounded-lg p-6 text-center">
      <h3 className="text-2xl font-semibold mb-4">
        <FontAwesomeIcon icon={faClinicMedical} className="mr-2 text-teal-600" /> Staff Home Visit
      </h3>
      <p>Our trained healthcare staff is ready to assist with daily care needs.</p>
      <img src="/staff.jpg" alt="Staff Home Visit" className="mt-4 w-full h-auto rounded-lg" />
      <div className='b'>
        <a href="https://wa.me/+919910967118" className="button-85 b" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Book Now
        </a>
      </div>
    </div>
  </div>
</section>

      
      <section
      id="about"
      className="bg-gray-100 py-16"
      
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center">
      
        <div className="w-full md:w-1/2 mb-8 md:mb-0">
        <Slider {...settings}>
    <div>
      <img
        src="/image1.jpg"
        alt="Home Healthcare 1"
        className="w-48 h-48 rounded-full mx-auto"
      />
    </div>
    <div>
      <img
        src="/image2.jpg"
        alt="Home Healthcare 2"
        className="w-48 h-48 rounded-full mx-auto"
      />
    </div>
    <div>
      <img
        src="/image3.jpg"
        alt="Home Healthcare 3"
        className="w-48 h-48 rounded-full mx-auto"
      />
    </div>
  </Slider>
        </div>

      
        <div className="w-full md:w-1/2 px-4 ps" >
          <h2 className="text-3xl font-semibold text-center md:text-left mb-6 ds" >
            About Us
          </h2>
          <p className="text-lg text-center md:text-left max-w-4xl mx-auto md:mx-0">
            Guardians Home Care was founded with the mission to bring quality
            healthcare to your home. Under the guidance of Dr. Kamal Gupta, our
            team provides personalized care that meets your unique needs.
          </p>
          <div className="flex justify-center mt-4 mmbt">
    
    <Link to="/about" ><button className="button-30">Learn More</button></Link>
    
  </div>
        </div>
      </div>
    </section>

    <section className="py-16 bg-gray-50">
  
  <div className="container mx-auto mb-16 text-center">
  
    <h2 className="text-3xl font-semibold mb-8">Meet Our Doctors</h2>
  
    <div className="flex flex-col md:flex-row justify-center gap-8 mb-8">
  
      <div className="doctor-card w-full md:w-1/3 p-4 bg-white rounded-lg shadow-lg">
        <img
          src="/doctor4.jpg"
          alt=" Dr. Divya Aggarwal"
          className="w-full rounded-md mb-4"
        />
        <h3 className="text-xl font-semibold mb-2">
        <FontAwesomeIcon icon={faUserMd} className="mr-2 text-blue-500" />
        Dr. Divya Aggarwal</h3>
        <p className="text-gray-600">Specialist in general medicine, minor surgical treatment, and critical care medicine.</p>
      </div>

      <div className="doctor-card w-full md:w-1/3 p-4 bg-white rounded-lg shadow-lg">
        <img
          src="/surgeon.jpg"
          alt="Dr. Neeraj Kumar"
          className="w-full rounded-md mb-4"
        />
        <h3 className="text-xl font-semibold mb-2">
        <FontAwesomeIcon icon={faUserMd} className="mr-2 text-blue-500" />
        Dr. Neeraj Kumar</h3>
        <p className="text-gray-600">Specialist in internal medicine with over 15 years of experience.</p>
      </div>

    </div>


    <div className="flex flex-col md:flex-row justify-center gap-8 mb-8">
   

  
      <div className="doctor-card w-full md:w-1/3 p-4 bg-white rounded-lg shadow-lg">
        <img
          src="/purush.jpg"
          alt="Dr. Purshotam Sharma"
          className="w-full rounded-md mb-4"
        />
        <h3 className="text-xl font-semibold mb-2">
        <FontAwesomeIcon icon={faUserMd} className="mr-2 text-blue-500" />
        Dr. Purshotam Sharma</h3>
        <p className="text-gray-600">Renowned general physician known for his compassionate care.</p>
      </div>
      <div className="doctor-card w-full md:w-1/3 p-4 bg-white rounded-lg shadow-lg">
        <img
          src="/doctor5.jpg"
          alt="Dr. Shatayu Aggarwal"
          className="w-full rounded-md mb-4"
        />
        <h3 className="text-xl font-semibold mb-2">
        <FontAwesomeIcon icon={faUserMd} className="mr-2 text-blue-500" />
        Dr. Shatayu Aggarwal </h3>
        <p className="text-gray-600">Chairman of Medical Committee (WAKO-INDIA)</p>
      </div>
      </div>


  
    <a href="/teamofdoctors" className="button-30">View All</a>
  </div>
</section>

<section className="py-16"
style={{
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundColor: '#f0f0f0'
}}>
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        
        <div className="w-full md:w-1/2 px-4 text-center md:text-left">
          <h2 className="text-3xl font-semibold text-center md:text-left mb-6 ds" >Rent Medical Equipment with Ease</h2>
          <p className="text-lg mb-6">
            Whether you need a wheelchair, oxygen concentrator, or any other medical equipment, Guardians Home Care offers a hassle-free rental service.
          </p>
        </div>

        
        <div className="w-full md:w-1/2 px-4">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={30}
            slidesPerView={1}
            loop={true}
            className="mySwiper"
          >
        
            <SwiperSlide>
              <img src="/DBLOODPM.jpg" alt="Digital Blood Pressure Monitor" className="w-full rounded-md shadow-lg" />

            </SwiperSlide>
            <SwiperSlide>
              <img src="/ultrasonic.jpg" alt="Ultrasonic Height and Weight Measurement Scale" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
              <img src="/DWS.jpg" alt="Digital Weighing Scale" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
            <img src="/TONOMETRY.jpg" alt="Portable Tonometry Device" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
              <img src="/GLUCOSE.jpg" alt="Blood Glucose Monitoring System" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
              <img src="/ECG.jpg" alt="ECG Monitor" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
              <img src="/ECGPAPER.jpg" alt="ECG Machine with Paper Printout " className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
            <SwiperSlide>
              <img src="/SPIROMETRE.jpg" alt="Spirometer" className="w-full rounded-md shadow-lg" />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="text-center mt-8">
        <a href="/equipmentrent" className="button-30">View All Equipment</a>
      </div>
    </section>
  
  


      
      <section id="contact" className="container mx-auto py-16">
        <h2 className="text-3xl font-semibold mb-8 text-center">Contact Us</h2>
        <div className="text-center">
          <p className="text-lg mb-4">Need assistance? We are here to help with all your healthcare needs.</p>
          <a href="/contact" className="text-teal-600 hover:text-teal-700 flex items-center justify-center">
            <FontAwesomeIcon icon={faHeadset} className="mr-2" /> Contact Us
          </a>
        </div>
      </section>

      

      <Footer />
    </div>
  );
}

export default Home;
